import React, { useContext } from "react";
import { Link, LinkProps } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import { LocaleContext } from "./layout";
import { locales } from "../../config/i18n";

interface LocalizedLinkProps extends LinkProps {
  to: string;
}

const LocalizedLink = React.forwardRef<HTMLAnchorElement, LocalizedLinkProps>(({ to, ...props }, ref) => {
  const { locale } = useContext(LocaleContext);

  const isIndex = to === "/";

  const path = locales[locale.split("-")[0]].default
    ? to
    : `/${locales[locale.split("-")[0]].path}${isIndex ? "" : `${to}`}`;

  return <Link as={GatsbyLink} to={path} ref={ref} {...props} />;
});

export default LocalizedLink;
